import { LtlPipelineViewModel } from "../../../../../ViewModel/LtlPipelineViewModel";

export const isLtlPipelineSpdr = (ltlPipeline: LtlPipelineViewModel) => {
  const field = "SpdrId";
  return (
    field in ltlPipeline &&
    ltlPipeline[field] !== undefined &&
    ltlPipeline[field] !== null
  );
};
